import React, { PropTypes } from "react";
import { FormattedDate, FormattedMessage } from "react-intl";
import { DropdownButton, MenuItem } from "react-bootstrap";
import classNames from "classnames";
import _ from "lodash";

import { BSModal } from "../../../../common/";
import { BasicFollowUpFields, NotesList } from "./";

import { getEnvironmentProperties } from "../../../../common/environmentProperties";
import userHasAccess from "../../../../../utils/userHasAccess";
import { FINTECH } from "../../../../../utils/Roles";

class FollowUps extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      followUpOriginType: "",
      opened: false,
      showModal: false,
      openedRight: true,
    };

    this.closeFollowUpForm = this.closeFollowUpForm.bind(this);
    this.createEditableFollowUpModel = this.createEditableFollowUpModel.bind(
      this
    );
    this.createEmptyFollowUpModel = this.createEmptyFollowUpModel.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.openFollowUpForm = this.openFollowUpForm.bind(this);
    this.toggleNotes = this.toggleNotes.bind(this);
    this.toggleRightPanel = this.toggleRightPanel.bind(this);
  }

  closeFollowUpForm() {
    this.setState({ showModal: false });
  }

  createEmptyFollowUpModel() {
    if (this.props.type == "client") {
      const { auth, client } = this.props;
      return {
        date: (
          <FormattedDate /** Created at date for creation (client) */
            value={new Date()}
            year="numeric"
            month="long"
            day="2-digit"
          />
        ),
        userId: auth.user.userId,
        user: `${auth.user.firstName} ${auth.user.lastName}`,
        priority: "MEDIUM",
        followUpType: "NOTE",
        followUpOriginType: this.state.followUpOriginType,
        followUpStatusType: "NEW",
        generateFollowUp: false,
        subType: "",
        description: "",
        transactionAmount: "",
        clientId: client.clientId,
        clientName: client.name,
        contactPhoneNumber: client.contactPhoneNumber,
        contactEmailAddress: client.contactEmailAddress,
        followUpGuid: "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function (c) {
            const r = (Math.random() * 16) | 0,
              v = c == "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
          }
        ),
      };
    } else {
      const { auth, member, clientId } = this.props;
      return {
        date: (
          <FormattedDate /** Created at date for creation (member) */
            value={new Date()}
            year="numeric"
            month="long"
            day="2-digit"
          />
        ),
        userId: auth.user.userId,
        user: `${auth.user.firstName} ${auth.user.lastName}`,
        priority: "MEDIUM",
        followUpType: "NOTE",
        followUpOriginType: this.state.followUpOriginType,
        followUpStatusType: "NEW",
        generateFollowUp: false,
        subType: "",
        description: "",
        transactionAmount: "",
        clientId: clientId,
        memberId: member.memberId,
        memberName: `${member.firstName} ${member.lastName}`,
        memberIdentifier: member.memberIdentifier,
        memberClient: member.client.name,
        memberPhoneNumber: member.customPhoneNumber,
        memberEmailAddress: member.customEmailAddress,
        profilePhone: member.phoneNumber,
        profileEmail: member.emailAddress,
        followUpGuid: "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function (c) {
            const r = (Math.random() * 16) | 0,
              v = c == "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
          }
        ),
      };
    }
  }

  createEditableFollowUpModel(followUp) {
    if (this.props.type == "client") {
      const { auth, client } = this.props;
      const user = followUp.createdByUser ? (
        `${followUp.createdByUser.firstName} ${followUp.createdByUser.lastName}`
      ) : (
        <FormattedMessage id="members.followUps.types.systemNote" />
      );

      let memberIdentifier = "";
      if(followUp.member && followUp.member.memberIdentifier) {
          memberIdentifier = followUp.member.memberIdentifier;
      }
      else if(followUp.memberIdentifier) {
          memberIdentifier = followUp.memberIdentifier;
      }
      if(client) followUp.clientStatusType = client.clientStatusType;
      return {
        ...followUp,
        priority: followUp.priority,
        date: (
          <FormattedDate /** Created at date for modification (client) */
            value={followUp.createdAt}
            year="numeric"
            month="long"
            day="2-digit"
          />
        ),
        deadline: followUp.deadline,
        user,
        incidentType: followUp.incidentType|| null,
        subType: followUp.specialModificationType||null,
        generateFollowUp: !!followUp.recipientUserId,
        clientId: followUp.clientId,
        clientName: !!followUp.client ? followUp.client.name : client.name,
        closeFollowUp: followUp.followUpStatusType === "CLOSED",
        contactPhoneNumber: !!followUp.client
          ? followUp.client.contactPhoneNumber
          : followUp.memberPhoneNumber,
        contactEmailAddress: !!followUp.client
          ? followUp.client.contactEmailAddress
          : followUp.memberEmailAddress,
        followUpClosedOn: !!followUp.closedDate ? (
          <FormattedDate /** Closed date for modification (client) */
            value={followUp.closedDate}
            year="numeric"
            month="long"
            day="2-digit"
          />
        ) : null,
        followUpClosedBy: !!followUp.closedByUser
          ? `${followUp.closedByUser.firstName} ${followUp.closedByUser.lastName}`
          : null,
        readOnly: !_.some(
          [followUp.recipientUserId, followUp.createdByUserId],
          (id) => id === auth.user.userId
        ),
          memberIdentifier: memberIdentifier,
      };

    } else {
      const { auth, member, clientId } = this.props;
      const user = followUp.createdByUser ? (
        `${followUp.createdByUser.firstName} ${followUp.createdByUser.lastName}`
      ) : (
        <FormattedMessage id="members.followUps.types.systemNote" />
      );

      if (member && member.client) followUp.clientStatusType = member.client.clientStatusType;
      return {
        ...followUp,
        date: (
          <FormattedDate /** Created at date for modification (member) */
            value={followUp.createdAt}
            year="numeric"
            month="long"
            day="2-digit"
          />
        ),
        user,
        subType: followUp.incidentType || followUp.specialModificationType,
        closeFollowUp: followUp.followUpStatusType === "CLOSED",
        generateFollowUp: !!followUp.recipientUserId,
        memberName: !!followUp.member
          ? `${followUp.member.firstName} ${followUp.member.lastName}`
          : followUp.memberName,
        memberIdentifier: !!followUp.member
          ? followUp.member.memberIdentifier
          : followUp.memberIdentifier,
        memberPhoneNumber: !!followUp.member
          ? followUp.member.customPhoneNumber
          : followUp.memberPhoneNumber,
        memberEmailAddress: !!followUp.member
          ? followUp.member.customEmailAddress
          : followUp.memberEmailAddress,
        memberClient: followUp.memberClient || member.client.name,
        clientId: clientId,
        profilePhone: !!followUp.member ? followUp.member.phoneNumber : "",
        profileEmail: !!followUp.member ? followUp.member.emailAddress : "",
        followUpClosedOn: !!followUp.closedDate ? (
          <FormattedDate /** Closed date for modification (member) */
            value={followUp.closedDate}
            year="numeric"
            month="long"
            day="2-digit"
          />
        ) : null,
        followUpClosedBy: !!followUp.closedByUser
          ? `${followUp.closedByUser.firstName} ${followUp.closedByUser.lastName}`
          : null,
        readOnly: !_.some(
          [followUp.recipientUserId, followUp.createdByUserId],
          (id) => id === auth.user.userId
        ),
      };
    }
    
  }

  onClick() {
    this.refs.form.getWrappedInstance().submit();
  }

  onSubmit(fields) {
    this.props.createNote({
      ...fields,
      followUpOriginType: this.state.followUpOriginType,
    });
    this.setState({ showModal: false });
  }

  openFollowUpForm(followUpOriginType) {
    this.setState({
      showModal: true,
      followUpOriginType,
      modalClassNames: "modal-follow-ups",
    });
  }

  toggleNotes(force) {
    this.setState({ opened: force == true || !this.state.opened });
  }

  toggleRightPanel() {
    this.setState({ openedRight: !this.state.openedRight });
    setTimeout(function () {
      const evt = document.createEvent("HTMLEvents");
      evt.initEvent("resize", true, false);
      window.dispatchEvent(evt);
    }, 0);
  }

  render() {
    const { member, client } = this.props;
    const isMemberArchived = member && member.isArchived && !userHasAccess(FINTECH);
    const isClientArchived = client && client.isArchived;
    const { displayEnvironmentOnScreen } = getEnvironmentProperties();

    const notesWrapperClassNames = classNames({
      "notes-wrapper": true,
      "member-notes": this.props.type == "member",
      opened: this.props.type == "client" && this.state.opened,
      "full-width": this.state.openedRight,
      "banner-offset": displayEnvironmentOnScreen && this.props.type != "member",
      "zero-width": !this.state.openedRight
    });
    const notesClassNames = classNames({
      "client-notes": this.props.type == "client",
      notes: true,
    });
    const chevronClassNames = classNames({
      icon: true,
      "icon-chevron-left": !this.state.opened,
      "icon-chevron-right": this.state.opened,
    });
    const chevronClassNamesRight = classNames({
      icon: true,
      "icon-chevron-left": !this.state.openedRight,
      "icon-chevron-right": this.state.openedRight,
    });
    const notesHeader = classNames({
      "notes-header": true,
      show: this.state.openedRight,
    });
    return (
      <div className={notesWrapperClassNames}>
        <div className="left-pane" onClick={this.toggleRightPanel}>
          <span className={chevronClassNamesRight} />
        </div>
        <div className={notesClassNames}>
          {this.props.type == "client" && (
            <div className="pull-out" onClick={this.toggleNotes}>
              <span className={chevronClassNames} />{" "}
              <span className="icon icon-folder-o" />
              <span className="count">{this.props.count}</span>
            </div>
          )}
          <div className={notesHeader}>
            <h4>
              <span className="icon icon-folder-o" />
              <FormattedMessage id="members.followUps.activities" />
            </h4>
            {!!this.props.count && (
              <span className="count">{this.props.count}</span>
            )}
            <DropdownButton disabled={isMemberArchived || isClientArchived} className="note-origin" id="note-origin" title="+">
              <MenuItem
                eventKey="1"
                onClick={this.openFollowUpForm.bind(this, "MANUAL")}
              >
                <span className="icon icon-align-left" />
                <FormattedMessage id="members.followUps.origin.note" />
              </MenuItem>
              <MenuItem
                eventKey="2"
                onClick={this.openFollowUpForm.bind(this, "EMAIL")}
              >
                <span className="icon icon-at" />
                <FormattedMessage id="members.followUps.origin.email" />
              </MenuItem>
              <MenuItem
                eventKey="3"
                onClick={this.openFollowUpForm.bind(this, "PHONE")}
              >
                <span className="icon icon-phone" />
                <FormattedMessage id="members.followUps.origin.phone" />
              </MenuItem>
            </DropdownButton>
            <div className="clearfix" />
            <BSModal
              className="extra-large-modal modal-follow-ups"
              show={this.state.showModal}
              title={
                <FormattedMessage id="members.followUps.addNote">
                  {(f) => (
                    <span
                      className={`icon note-origin ${this.state.followUpOriginType.toLowerCase()}`}
                    >
                      {f}
                    </span>
                  )}
                </FormattedMessage>
              }
              actions={[
                {
                  id: 1,
                  disabled: false,
                  text: <FormattedMessage id="common.confirm" />,
                  action: this.onClick,
                },
              ]}
              onClose={this.closeFollowUpForm}
            >
              <BasicFollowUpFields
                ref={"form"}
                type={this.props.type}
                onSubmit={this.onSubmit}
                initialValues={this.createEmptyFollowUpModel()}
                add={true}
                needsActiveProperty={this.props.needsActiveProperty}
              />
            </BSModal>
          </div>
          <NotesList
            type={this.props.type}
            followUps={this.props.followUps}
            updateNote={this.props.updateNote}
            createEditableFollowUpModel={this.createEditableFollowUpModel}
            needsActiveProperty={this.props.needsActiveProperty}
            paneOpen={this.state.openedRight}
          />
        </div>

        <div
          className="overlay"
          onClick={() => {
            this.toggleNotes(false);
          }}
        />
      </div>
    );
  }
}

FollowUps.propTypes = {
  auth: PropTypes.object,
  clientId: PropTypes.number,
  client: PropTypes.object,
  count: PropTypes.number,
  createNote: PropTypes.func,
  dataActions: PropTypes.object,
  followUps: PropTypes.array,
  member: PropTypes.object,
  type: PropTypes.string,
  updateNote: PropTypes.func.isRequired,
  needsActiveProperty: PropTypes.bool
};

export default FollowUps;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/FollowUps.js